

export class SalarySummaryDto implements ISalarySummaryDto {
    id!: number;
    employeeId!: number;
    empName!: string | undefined;
    empCode!: string | undefined;
    salaryMonth!: Date | undefined;
    finalSalary!: number | undefined;
    payDate!: Date | undefined;
    workingDay!: number;
    branchId!: number;
    branchName!: string | undefined;
    backHighlightColor!: string | undefined;
    displayName!: string | undefined;
    locationName!: string | undefined;
    empLegalName!: string | undefined;

    constructor(data?: ISalarySummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.empName = _data["empName"];
            this.empCode = _data["empCode"];
            this.salaryMonth = _data["salaryMonth"] ? new Date(_data["salaryMonth"].toString()) : <any>undefined;
            this.finalSalary = _data["finalSalary"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.workingDay = _data["workingDay"];
            this.branchId = _data["branchId"];
            this.branchName = _data["branchName"];
            this.backHighlightColor = _data["backHighlightColor"];
            this.displayName = _data["displayName"];
            this.locationName = _data["locationName"];
            this.empLegalName = _data["empLegalName"];
        }
    }

    static fromJS(data: any): SalarySummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalarySummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["empName"] = this.empName;
        data["empCode"] = this.empCode;
        data["salaryMonth"] = this.salaryMonth ? this.salaryMonth.toISOString() : <any>undefined;
        data["finalSalary"] = this.finalSalary;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["workingDay"] = this.workingDay;
        data["branchId"] = this.branchId;
        data["branchName"] = this.branchName;
        data["backHighlightColor"] = this.backHighlightColor;
        data["displayName"] = this.displayName;
        data["locationName"] = this.locationName;
        data["empLegalName"] = this.empLegalName;
        return data; 
    }
}

export interface ISalarySummaryDto {
    id: number;
    employeeId: number;
    empName: string | undefined;
    empCode: string | undefined;
    salaryMonth: Date | undefined;
    finalSalary: number | undefined;
    payDate: Date | undefined;
    workingDay: number;
    branchId: number;
    branchName: string | undefined;
    backHighlightColor: string | undefined;
    displayName: string | undefined;
    locationName: string | undefined;
    empLegalName: string | undefined;
}

